import { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { getLatestVideosAction } from "../../apis/apiAction";

const LatestVideos = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    getLatestVideos();
  }, []);

  const getLatestVideos = async () => {
    try {
      const res = await getLatestVideosAction();
      if (res?.data && Array.isArray(res.data)) {
        setVideos(res.data);
      } else {
        console.error("Invalid response:", res);
        setVideos([]);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
      setVideos([]);
    }
  };

  // Show only the latest video (first in the list)
  const latestVideo = videos.length > 0 ? videos[0] : null;
  const relatedVideos = videos.slice(1)
  console.log('123',videos)

  return (
    <Container fluid>
      <Row>
        {latestVideo && latestVideo.link ? (
          <Col lg={12} className="">
            <div className="w-100">
              <Card className="lightBlueCard rounded-0 border-0 text-start">
                <div className="ratio ratio-16x9">
                  <iframe
                    width="100%"
                    height="315"
                    src={latestVideo.link}
                    title={latestVideo.title || "Latest Video"}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Card>
            </div>
          </Col>
        ) : (
          <Col lg={12} className="text-center text-white">
            <p>No video available</p>
          </Col>
        )}
        <Col lg={12} className=" mt-3 mb-2">
          <hr />
        </Col>
      </Row>
      <Row>
        <Col lg={12} className=" mb-4">
          <h3 className="text-white">Related videos</h3>
        </Col>
        {relatedVideos.length > 0 ? (
          relatedVideos.map((video, index) => (
          <Col key={index} lg={4} className="mb-5">
            <div className="ratio ratio-16x9 rounded-5 overflow-hidden">
              <iframe
                width="100%"
                height="315"
                src={video.link}
                title={video.title || "Related Video"}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <Button className="btn-sm rounded-5 my-3 x-small">Podcast</Button>
            <h5 className="text-white">
              {video.title || "Untitled Video"}
            </h5>
            <div className="text-primary fw-semibold my-3">
              {video.publishedDate
                ? video.publishedDate.split("T")[0]
                : "Unknown Date"}
            </div>
          </Col>
          ))
        ) : (
          <Col xl={4} lg={6} md={6} className="mb-5 text-white">
            <p>No video available</p>
          </Col>
        )}

        
      </Row>
    </Container>
  );
};

export default LatestVideos;
